module.exports = __webpack_public_path__ + "img/cl-install-CW-8000-association.4b2d951f.png";